import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import sourceflowEnums from "@/sourceflow.enums";

import { router } from "@/routes";

export { default } from 'pages/blog'

export async function getStaticProps() {
    const global = (await Global()).toJson();

    const events = (await Collection(`events`))
        .filter(post => {
            // Event value id
            return post?.blog_category.en.includes("99fb1780-6d53-482f-9f68-41dd8822d807");
        })
        .orderBy(['published_date.en'], ['desc'])
        .getItems()
    const blogs = (await Collection(`blog`))
        .filter(post => {
            // Blog value id
            return post?.blog_category.en.includes("97a9d871-fff6-412b-aeae-c5db0ffab697");
        })
        .orderBy(['published_date.en'], ['desc'])
        .getItems()
    const downloads = (await Collection(`downloads`))
        .filter(post => {
            // Downloads value id
            return post?.blog_category.en.includes("af8c0068-1fd0-4028-afb1-c1d1ed6ea2ef");
        })
        .orderBy(['published_date.en'], ['desc'])
        .getItems()
    const reviews = (await Collection(`reviews`))
        .filter(post => {
            // Reviews value id
            return post?.blog_category.en.includes("b35b49e3-8bee-42f0-bc91-aa5076e43ae9");
        })
        .orderBy(['published_date.en'], ['desc'])
        .getItems()


    const combinedResources = [...events, ...blogs, ...downloads, ...reviews];


    const blog_tags = (await Collection(`blog_tags`)).getItems()
    const blog_category = (await Collection(`blog_category`)).getItems()

    const routerKey = "resources";
    return {
        props: {
            global,
            combinedResources,
            blogs: combinedResources,
            blog_category,
            blog_tags,
            meta: {
                title: "Resources | Tradewind Recruitment",
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            },
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search